export default "/_next/static/images/apple-touch-icon-iphone4-a04415ea096f53d8d39d36d388e5d410.png";